/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from "react";

import { createComponent } from "@evertrue/et-flux";
import { div, span, button } from "react-dom-factories";
import { Icon } from "components/et-factories";
import PropTypes from "prop-types";

export default createComponent("LinkedinButton", {
  propTypes: {
    onClick: PropTypes.func,
  },

  render() {
    return button(
      { className: "linkedin-btn", onClick: this.props.onClick },
      div({ className: "linkedin-btn--icon" }, Icon({ icon: "linkedin" })),
      span({ className: "linkedin-btn--text" }, "Connect with LinkedIn"),
    );
  },
});
